/** Import React and 3rd party libs */
import React, { useEffect } from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import MaterialCheckbox from "@material-ui/core/Checkbox";
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";

// @material-ui/icons
import Check from "@material-ui/icons/Check";

// Components
/** Import generic components - internal and creative tim */

// Subcomponents
import StepNote from "../../StepComponents/StepNote";
import ViewTitle from "../../StepComponents/ViewTitle";

// Services
import { getCommonTabs, isInputDisabled, EditRow } from "../StepTypesUtility";
import { toggleCheckbox, getStepRowClass } from "services/StepService";

// Queries
/** Import all graphql queries */

// Assets
import stepsStyle from "assets/jss/material-dashboard-pro-react/components/stepsStyle.jsx";

// Variables

const PLUGIN_FRAME = "PLUGIN_FRAME";

// Functions

const StepIcon = ({ classes, step, updateStep, mode }) => {
  return (
    <TableCell className={classes.tableCheck}>
      <MaterialCheckbox
        checked={step.value ? step.value.checked : false}
        disabled={isInputDisabled(mode)}
        tabIndex={-1}
        onClick={() => updateStep(toggleCheckbox(step))}
        checkedIcon={<Check className={classes.checkedSuccessIcon} />}
        icon={<Check className={classes.uncheckedIcon} />}
        classes={{
          checked: classes.checkedSuccess,
          root: classes.checkRoot
        }}
      />
    </TableCell>
  );
};

const StepContent = props => {
  const { classes } = props;

  useEffect(() => {
    const POSITION_DEFAULT = {
      id: "NEWEST_UUID", // Pass in from source
      lat: 37.416079201510435,
      lon: -122.11795042544621
    };
    window.setUpPlugin = function() {
      var frame = window.frames[PLUGIN_FRAME];
      frame.setPosition(POSITION_DEFAULT);
    };
  }, []);

  return (
    <TableCell className={classes.tableContent}>
      <ViewTitle {...props} />
      <iframe
        name={PLUGIN_FRAME}
        width="540"
        height="500"
        style={{ border: 0 }}
        src="/plugin/weather/build/index.html"
      />
    </TableCell>
  );
};

/**
 * Plugin Step
 */
const Plugin = props => {
  const {
    classes,
    step,
    updateStep,
    editing,
    setEditState,
    noteOpen,
    setNoteState
  } = props;
  const editProps = { editing, setEditState, noteOpen, setNoteState };
  const tabs = getCommonTabs(step, updateStep);
  const showRowDividers = true;
  const primaryTableRowClass = getStepRowClass(
    classes,
    showRowDividers,
    editing || noteOpen
  );

  return (
    <>
      <TableRow key={step.stepId} className={primaryTableRowClass}>
        <StepIcon {...props} step={step} />
        <StepContent {...props} {...editProps} step={step} />
      </TableRow>
      <EditRow classes={classes} open={editing}>
        <CustomTabs title="Configure" headerColor="gray" tabs={tabs} />
      </EditRow>
      <EditRow classes={classes} open={noteOpen}>
        <StepNote step={step} updateStep={updateStep} />
      </EditRow>
    </>
  );
};

export default withStyles(stepsStyle)(Plugin);
